import React from 'react';

import { clsx } from 'clsx';

import { useLayoutContext } from '@ott/layout-context';

import FadeIn from 'src/components/elements/FadeIn';
import Card from 'src/components/pages/PartnersPage/components/Card';
import { KeyFeaturesCards, PartnersLogos } from 'src/components/pages/PartnersPage/constants';

import styles from './KeyFeatures.scss';

const PartnersLogosFirstRow = PartnersLogos.slice(0, 4);
const PartnersLogosOthersRow = PartnersLogos.slice(4);

const KeyFeatures = () => {
  const { isDesktop } = useLayoutContext();

  return (
    <section data-locator="partnersKeyFeatures" className={styles.keyFeatures}>
      <FadeIn delay={0.2}>
        <p className={styles.title}>
          <span className={clsx(styles.title, styles.titleThin)}>Our</span> key features
        </p>
      </FadeIn>
      <FadeIn delay={0.6}>
        <div className={styles.cardsContainer}>
          {KeyFeaturesCards.map((card) => (
            <Card item={card} cardStyle={styles.cardContainer} bigCard={true} key={card.id} />
          ))}
        </div>
        <p className={styles.logosTitle}>Powered by our tech partners</p>
        {isDesktop ? (
          <>
            <div className={clsx(styles.logosContainer, styles.firstRow)}>
              {PartnersLogosFirstRow.map((item) => (
                <img src={item.logo} key={item.id} alt="" />
              ))}
            </div>
            <div className={styles.logosContainer}>
              {PartnersLogosOthersRow.map((item) => (
                <img src={item.logo} className={styles.logo} key={item.id} alt="" />
              ))}
            </div>
          </>
        ) : (
          <div className={styles.logosContainer}>
            {PartnersLogosFirstRow.map((item) => (
              <img src={item.logo} className={styles.logoFirstRow} key={item.id} alt="" />
            ))}
            {PartnersLogosOthersRow.map((item) => (
              <img src={item.logo} className={styles.logo} key={item.id} alt="" />
            ))}
          </div>
        )}
      </FadeIn>
    </section>
  );
};

export default KeyFeatures;
